import dayjs from 'dayjs';
import localeDataPlugin from 'dayjs/plugin/localeData';
import localizedFormatPlugin from 'dayjs/plugin/localizedFormat';
import advancedFormatPlugin from 'dayjs/plugin/advancedFormat';
import customParseFormatPlugin from 'dayjs/plugin/customParseFormat';
import isBetweenPlugin from 'dayjs/plugin/isBetween';
import isSameOrBeforePlugin from 'dayjs/plugin/isSameOrBefore';
import shoplineZhHant from './shopline-locale-zh-hant';
import shoplineZhCn from './shopline-locale-zh-cn';
import shoplineEn from './shopline-locale-en';
import shoplineVi from './shopline-locale-vi';
import shoplineTh from './shopline-locale-th';
export const dayJSLocaleMap = {
    en: shoplineEn,
    'zh-hant': shoplineZhHant,
    'zh-cn': shoplineZhCn,
    vi: shoplineVi,
    th: shoplineTh,
};
dayjs.extend(customParseFormatPlugin);
dayjs.extend(localeDataPlugin);
dayjs.extend(localizedFormatPlugin);
dayjs.extend(advancedFormatPlugin);
dayjs.extend(isBetweenPlugin);
dayjs.extend(isSameOrBeforePlugin);
export default dayjs;
//# sourceMappingURL=dayjs.js.map